import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { APP_VERSION } from '../utils/version';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [locked, setLocked] = useState(null); // { lockedUntil } gdy konto zablokowane (T43)
  const [loading, setLoading] = useState(false);
  // T171: przekierowanie po 30 min bezczynności
  const idleLogout = new URLSearchParams(window.location.search).get('bezczynnosc') === '1';
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLocked(null);
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      if (err.status === 423) setLocked({ lockedUntil: err.data?.lockedUntil, stage: err.data?.stage || 1 });
      setError(err.message || 'Błąd logowania');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div style={{ fontSize: 32, textAlign: 'center', marginBottom: 8 }}>🎪</div>
        <div className="login-title">FunHR</div>
        <div className="login-sub">Zaloguj się do panelu zarządzania</div>

        {idleLogout && !error && (
          <div style={{ background: '#FFFBEB', border: '1px solid #FDE68A', color: '#92400E', borderRadius: 8, padding: '10px 12px', fontSize: 12, marginBottom: 10 }}>
            Wylogowano po 30 minutach bezczynności — zaloguj się ponownie.
          </div>
        )}
        {error && !locked && <div className="login-error">{error}</div>}
        {locked && (
          <div style={{ background: '#FEF2F2', border: '1px solid #FCA5A5', color: '#991B1B', borderRadius: 8, padding: '10px 12px', fontSize: 12, marginBottom: 10 }}>
            <b>Konto zablokowane.</b><br />{error}
            {locked.lockedUntil && (
              <div style={{ marginTop: 6, color: '#B91C1C', fontSize: 11 }}>
                Blokada wygaśnie {new Date(locked.lockedUntil).toLocaleString('pl-PL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}.
                Po niej masz <b>jedną</b> próbę — kolejny błąd zablokuje konto {locked.stage >= 2 ? 'na stałe (odblokowuje administrator)' : 'na 6 godzin'}.
              </div>
            )}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div className="input-group">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="twoj@email.pl" required autoFocus />
          </div>
          <div className="input-group">
            <label>Hasło</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" required />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}
            style={{ width: '100%', padding: '10px', fontSize: 14, marginTop: 4, justifyContent: 'center' }}>
            {loading ? 'Logowanie...' : 'Zaloguj się'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 11, color: '#94A3B8' }}>
          Nie pamiętasz hasła? Skontaktuj się z administratorem —<br />ustawi Ci nowe.
        </div>
        <div style={{ textAlign: 'center', marginTop: 10, fontSize: 10, color: '#CBD5E1' }}>FunHR v{APP_VERSION}</div>
      </div>
    </div>
  );
}
